import { RouteName } from "../RouteNames";

export const nominationRoutes = {
  name: RouteName.Nominations,
  path: "/nominations",
  component: () =>
    import("@follaw-fr/views/side_menu_views/NominationsView.vue"),
  meta: { permission_level: "SOCIETAL" },
};
